import getApi from '../../api/apisauceConfig'
import { TaskFilters } from '../../model/Task'

export const getTaskCount = (filters?: TaskFilters, signal?: AbortSignal) =>
  getApi().get<number | null>('/tasks/count', { ...filters }, { signal })
